import {
  AddNewQuestionAction,
  AddNewQuestionPayload,
  AddNewTaskAction,
  AddNewTaskPayload,
  AddSelectedFileAction,
  AddSelectedFilePayload,
  ClearCurrentTaskSelectedFilesAction,
  ClearStreamingAnswerChunkTasksAction,
  ClearTemporaryTaskAction,
  DeleteTaskAction,
  DeleteTaskPayload,
  EditQuestionAction,
  EditQuestionPayload,
  EditTaskNameAction,
  EditTaskNamePayload,
  GetDetailTaskAction,
  GetDetailTaskPayload,
  GetLatestTaskAction,
  GetTasksAction,
  GetTasksPayload,
  LoadTemporaryTaskDataAction,
  RemoveSelectedFileAction,
  RemoveSelectedFilePayload,
  ResetDataAction,
  SetTimeOutForFinalAnswerTaskAction,
  SetTimeOutForFinalAnswerTaskPayload,
  UpdateCurrentQuestionAction,
  UpdateCurrentQuestionPayload,
  UpdateCurrentTaskAction,
  UpdateCurrentTaskDataAction,
  UpdateCurrentTaskDataPayload,
  UpdateCurrentTaskPayload,
  UpdateFileStatusAction,
  UpdateFileStatusPayload,
  UpdateInitialSelectedFilesAction,
  UpdateLimitStatusAction,
  UpdateLimitStatusPayload,
  UpdateNewAnswerAction,
  UpdateNewAnswerChunkTaskPayload,
  UpdateNewAnswerPayload,
  UpdateNewQuestionAction,
  UpdateNewQuestionPayload,
  UpdateNewStreamingAnswerChunkTasksAction,
  UpdateProcessTaskIdAction,
  UpdateProcessTaskIdPayload,
  UpdateSelectedFileAction,
  UpdateSelectedFilePayload,
  UpdateStatusAction,
  UpdateStatusPayload,
  UpdateStreamingChunkStatusTaskAction,
  UpdateStreamingChunkStatusTaskPayload,
  UpdateTasksAction,
  UpdateTasksPayload,
  UpdateTemporaryTaskIdAction,
  UpdateTemporaryTaskIdPayload,
} from 'types/actions/task';

import { taskConstant } from '../actionTypes';

export const getTasks = (payload?: GetTasksPayload): GetTasksAction => ({
  type: taskConstant.GET_TASKS,
  payload,
});

export const updateTasks = (payload: UpdateTasksPayload): UpdateTasksAction => ({
  type: taskConstant.UPDATE_TASKS,
  payload,
});

export const deleteTask = (payload: DeleteTaskPayload): DeleteTaskAction => ({
  type: taskConstant.DELETE_TASK,
  payload,
});

export const updateStatus = (payload: UpdateStatusPayload): UpdateStatusAction => ({
  type: taskConstant.UPDATE_STATUS_TASK,
  payload,
});

export const updateCurrentQuestion = (
  payload: UpdateCurrentQuestionPayload
): UpdateCurrentQuestionAction => ({
  type: taskConstant.UPDATE_CURRENT_QUESTION_TASK,
  payload,
});

export const updateCurrentTaskData = (
  payload: UpdateCurrentTaskDataPayload
): UpdateCurrentTaskDataAction => ({
  type: taskConstant.UPDATE_CURRENT_TASK_DATA,
  payload,
});

export const clearCurrentTaskSelectedFiles = (): ClearCurrentTaskSelectedFilesAction => ({
  type: taskConstant.CLEAR_CURRENT_TASK_SELECTED_FILES,
});

export const clearTemporaryTask = (): ClearTemporaryTaskAction => ({
  type: taskConstant.CLEAR_TEMPORARY_TASK,
});

export const loadTemporaryTaskData = (): LoadTemporaryTaskDataAction => ({
  type: taskConstant.LOAD_TEMPORARY_TASK_DATA,
});

export const updateCurrentTask = (payload: UpdateCurrentTaskPayload): UpdateCurrentTaskAction => ({
  type: taskConstant.UPDATE_CURRENT_TASK,
  payload,
});

export const updateProcessTaskId = (
  payload: UpdateProcessTaskIdPayload
): UpdateProcessTaskIdAction => ({
  type: taskConstant.UPDATE_PROCESS_TASK_ID,
  payload,
});

export const updateTemporaryTaskId = (
  payload: UpdateTemporaryTaskIdPayload
): UpdateTemporaryTaskIdAction => ({
  type: taskConstant.UPDATE_TEMPORARY_TASK_ID,
  payload,
});

export const getLatestTask = (): GetLatestTaskAction => ({
  type: taskConstant.GET_LATEST_TASK,
});

export const getDetailTask = (payload: GetDetailTaskPayload): GetDetailTaskAction => ({
  type: taskConstant.GET_DETAIL_TASK,
  payload,
});

export const editTaskName = (payload: EditTaskNamePayload): EditTaskNameAction => ({
  type: taskConstant.EDIT_TASK_NAME,
  payload,
});

export const addNewQuestion = (payload: AddNewQuestionPayload): AddNewQuestionAction => ({
  type: taskConstant.ADD_NEW_QUESTION_TASK,
  payload,
});

export const editQuestion = (payload: EditQuestionPayload): EditQuestionAction => ({
  type: taskConstant.EDIT_QUESTION_TASK,
  payload,
});

export const updateNewQuestion = (payload: UpdateNewQuestionPayload): UpdateNewQuestionAction => ({
  type: taskConstant.UPDATE_NEW_QUESTION_TASK,
  payload,
});

export const addNewTask = (payload: AddNewTaskPayload): AddNewTaskAction => ({
  type: taskConstant.ADD_NEW_TASK,
  payload,
});

export const updateNewAnswer = (payload: UpdateNewAnswerPayload): UpdateNewAnswerAction => ({
  type: taskConstant.UPDATE_NEW_ANSWER_TASK,
  payload,
});

export const updateLimitStatus = (payload: UpdateLimitStatusPayload): UpdateLimitStatusAction => ({
  type: taskConstant.UPDATE_LIMIT_STATUS_TASK,
  payload,
});

export const addSelectedFile = (payload: AddSelectedFilePayload): AddSelectedFileAction => ({
  type: taskConstant.ADD_SELECTED_FILE,
  payload,
});

export const updateSelectedFile = (
  payload: UpdateSelectedFilePayload
): UpdateSelectedFileAction => ({
  type: taskConstant.UPDATE_SELECTED_FILE,
  payload,
});

export const removeSelectedFile = (
  payload: RemoveSelectedFilePayload
): RemoveSelectedFileAction => ({
  type: taskConstant.REMOVE_SELECTED_FILE,
  payload,
});

export const updateFileStatus = (payload: UpdateFileStatusPayload): UpdateFileStatusAction => ({
  type: taskConstant.UPDATE_FILE_STATUS,
  payload,
});

export const updateInitialSelectedFiles = (): UpdateInitialSelectedFilesAction => ({
  type: taskConstant.UPDATE_INITIAL_SELECTED_FILES,
});

export const resetData = (): ResetDataAction => ({
  type: taskConstant.RESET_DATA,
});

export const updateProcessingStreamingChunkStatusTask = (
  payload: UpdateStreamingChunkStatusTaskPayload
): UpdateStreamingChunkStatusTaskAction => ({
  type: taskConstant.UPDATE_PROCESSING_STREAMING_CHUNK_STATUS_TASK,
  payload,
});

export const updateNewStreamingAnswerChunksTask = (
  payload: UpdateNewAnswerChunkTaskPayload
): UpdateNewStreamingAnswerChunkTasksAction => ({
  type: taskConstant.UPDATE_NEW_STREAMING_ANSWER_CHUNKS_TASK,
  payload,
});

export const clearStreamingAnswerChunksTask = (): ClearStreamingAnswerChunkTasksAction => ({
  type: taskConstant.CLEAR_STREAMING_ANSWER_CHUNKS_TASK,
});

export const setTimeOutForFinalAnswerTask = (
  payload: SetTimeOutForFinalAnswerTaskPayload
): SetTimeOutForFinalAnswerTaskAction => ({
  type: taskConstant.SET_TIMEOUT_FOR_FINAL_ANSWER_TASK,
  payload,
});
